"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createB2bApi = void 0;
var tslib_1 = require("tslib");
var withHttpClient_1 = require("../hocs/withHttpClient");
var b2bApi = function b2bApi(_a) {
  var httpClient = _a.httpClient;
  var fetchCompaniesListByQuery = function fetchCompaniesListByQuery(search) {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: 'api/search-company',
              queryParams: {
                search: search
              }
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  };
  function fetchCompanyByName(name) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: 'api/company',
              queryParams: {
                name: name
              }
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  }
  function postEligibilityCheck(body) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: 'api/eligibility',
              data: body
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  }
  function createLead(body) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.post({
              endpoint: 'api/lead',
              data: body
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  }
  function fetchEmployeeEnrolmentData(authToken) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var res;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, httpClient.get({
              endpoint: 'api/enrolment',
              options: {
                headers: {
                  Authorization: "Bearer ".concat(authToken)
                }
              }
            })];
          case 1:
            res = _a.sent();
            return [2, res.data.data];
        }
      });
    });
  }
  return {
    fetchCompaniesListByQuery: fetchCompaniesListByQuery,
    fetchCompanyByName: fetchCompanyByName,
    postEligibilityCheck: postEligibilityCheck,
    createLead: createLead,
    fetchEmployeeEnrolmentData: fetchEmployeeEnrolmentData
  };
};
exports.createB2bApi = (0, withHttpClient_1.withHttpClient)(b2bApi);